import store from '@frontend/store'

const downloadFile = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default {
    isBynderImageUrl(url) {
        if (typeof url !== 'string') return false;

        return url.includes('bynder.com');
    },

    async getMetaproperties() {
        try {
            const { data } = await axios.post('/bynder/fetch-all-metaproperties');

            if (data.status === 'error') {
                console.error('Error fetching metaproperties:', data.message);
                return [];
            }

            const properties = Array.isArray(data.properties) ? data.properties : Object.values(data.properties);

            return properties;
        } catch (error) {
            console.error('Error fetching metaproperties:', error);
            return [];
        }
    },

    async downloadAllFormats(payload) {
        try {
            toastr.info('Downloading started...');

            store.commit('fileBrowser/SET_BYNDER_DOWNLOADING', true);

            const { data } = await axios.post('/bynder/download-all-formats', payload);

            if (data.status === 'error') {
                toastr.error(data.message);
            }

            if (data.url) {
                downloadFile(data.url, data.fileName);

                if (data.itemsDownloaded && data.totalItems) {
                    toastr.success(`Downloaded ${data.itemsDownloaded} of ${data.totalItems} formats`);
                }
            }

            return data;
        } catch (error) {
            console.log('Error', error.message);

            toastr.error('Download all formats failed. Try again later.');
        } finally {
            store.commit('fileBrowser/SET_BYNDER_DOWNLOADING', false);
        }
    },

    async downloadAssets(payload) {
        try {
            toastr.info('Downloading started...');

            const { data } = await axios.post('/bynder/download-assets', payload);

            if (data.status === 'error') {
                toastr.error(data.message);
            }

            if (data.url) {
                downloadFile(data.url, data.fileName);
            }

            toastr.success('Download completed');

            return data;
        } catch (error) {
            console.log('Error', error.message);

            toastr.error('Download failed. Try again later.');
        }
    }
}
